var map = {
	"./decidim/avatar-multiuser.png": 6616,
	"./decidim/brands/google.svg": 4359,
	"./decidim/cc-badge.png": 3714,
	"./decidim/decidim-logo.svg": 8298,
	"./decidim/default-avatar.svg": 9990,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 2714,
	"./decidim/icons.svg": 681,
	"./decidim/pattern.png": 5270,
	"./decidim/placeholder-card-g.svg": 7403,
	"./decidim/placeholder-card-l.svg": 2928,
	"./decidim/placeholder.jpg": 5079,
	"./decidim/remixicon.symbol.svg": 4287,
	"./decidim/vendor/leaflet/layers-2x.png": 9858,
	"./decidim/vendor/leaflet/layers.png": 6425,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 896,
	"./decidim/vendor/leaflet/marker-icon.png": 5023,
	"./decidim/vendor/leaflet/marker-shadow.png": 6924,
	"./decidim/vendor/social-share-button/douban.svg": 1630,
	"./decidim/vendor/social-share-button/email.svg": 2379,
	"./decidim/vendor/social-share-button/facebook.svg": 378,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 6740,
	"./decidim/vendor/social-share-button/hacker_news.svg": 7407,
	"./decidim/vendor/social-share-button/linkedin.svg": 291,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 4844,
	"./decidim/vendor/social-share-button/pinterest.svg": 7629,
	"./decidim/vendor/social-share-button/reddit.svg": 6013,
	"./decidim/vendor/social-share-button/telegram.svg": 1444,
	"./decidim/vendor/social-share-button/tumblr.svg": 9003,
	"./decidim/vendor/social-share-button/twitter.svg": 7194,
	"./decidim/vendor/social-share-button/vkontakte.svg": 1268,
	"./decidim/vendor/social-share-button/wechat.svg": 2431,
	"./decidim/vendor/social-share-button/whatsapp.svg": 2719,
	"./decidim/vendor/social-share-button/x.svg": 3339,
	"./decidim/vendor/social-share-button/xing.svg": 8189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3551;